import { render, staticRenderFns } from "./PMPositionsTable.vue?vue&type=template&id=4483a335&"
import script from "./PMPositionsTable.vue?vue&type=script&lang=ts&"
export * from "./PMPositionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PMPositionsTable.vue?vue&type=style&index=0&id=4483a335&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports